import React, { Component } from "react";
import ResizeObserver from "resize-observer-polyfill";
import capitalize from "lodash/capitalize";
import { RESOLUTIONS } from "services/config";
/** v3 imports */
import Modal from "sub_components/Common/PortalModalNew";
import { PopUp } from "styled_components/Common/PopUp";
import NavSection from "./Navigation/BloxNavigationSection";
import ContentSection from "./ContentSection";
import { LowResMessage } from "./LowResolutionPopUp";

// import HeaderSection from './Header/HeaderSection';
import HeaderSection from "./Header/HeaderSectionNoGrid";
import FooterSection from "./Footer/Footer";
import AlertBanner from "./AlertBanner";

const CDN_URL = process.env.REACT_APP_CDN_URL;
// import { SITE_MAP, SITE_PAGES } from './../Common/CommonConstants';

const PAGES = {
  Support: {
    Overview: "OverviewPage",
    Ticket_history: "TicketHistoryPage",
  },
  Colocation: {
    Overview: "OverviewPage",
    Power: "PowerPage",
    Network: "NetworkPage",
    Environment: "EnvironmentPage",
    Rack: "RackOverview",
  },
  Storage: {
    Overview: "OverviewPage",
    Manage_storage: "ManageStoragePage",
    Share_detail: "ShareDetailsPage",
  },
  Account: {
    Overview: "OverviewPage",
    User_management: "UserMgmtPage",
    Account_management: "UserMgmtPage",
    My_profile: "MyProfilePage",
    Company_profile: "CompanyProfilePage",
    Notifications: "NotificationsPage",
    Change_password: "PasswordChangePage",
    Documents: "DocumentsPage",
    Avatar: "AvatarChangePage",
    Contact_info: "UserInfoPage",
  },
  Billing: {
    Overview: "OverviewPage",
    Current_invoices: "CurrentInvoicesPage",
    Invoice_history: "InvoiceHistoryPage",
    Invoice_detail: "InvoiceDetailPage",
    Make_a_payment: "MakeAPaymentPage",
  },
};

class PortalLayout extends Component {
  constructor(props) {
    super(props);

    this.screenObserver = null;
    this.state = {
      currentModule: null,
      currentPage: null,
      // breakpoint: 1440,
      breakpoint: RESOLUTIONS.MED,
      screenWidth: null,
      modalContent: null,
      modalOpen: false,
      headerText: null,
      customImage: null,
      customTitle: null,
      whitelistModalOpen: false,
      id: null,
      whitelist: null,
      interiorWall: null,
    };
  }

  /**
   * For v3 URL driven portal requirements
   */
  parseUrlParams = () => {
    const matches = location.pathname.split("/");

    if (matches) {
      const [, , siteModule, sitePage] = matches;
      const parsedSitePage =
        !sitePage || sitePage === undefined || sitePage === "0"
          ? "OVERVIEW"
          : sitePage;
      this.loadPage(siteModule, parsedSitePage);
      return { siteModule, parsedSitePage };
    }

    return { siteModule: "HOME", sitePage: "OVERVIEW" };
  };

  loadPage = (bloxModule, bloxPage = "OVERVIEW") => {
    const mod = capitalize(bloxModule);
    const page = capitalize(bloxPage);
    const pageName = PAGES[mod][page];

    const Component = require(`../../pages/${mod}/${pageName}`).default;
    this.setState({
      PageComponent: Component,
      currentModule: mod.toLowerCase(),
    });
  };

  updateScreenBreakpoint = (screenWidth, screenHeight) => {
    let breakpoint = RESOLUTIONS.MED;

    if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
      breakpoint = RESOLUTIONS.LOW;
    } else if (
      screenWidth > RESOLUTIONS.MED &&
      screenWidth <= RESOLUTIONS.HIGH
    ) {
      breakpoint = RESOLUTIONS.MED;
    } else if (screenWidth > RESOLUTIONS.HIGH) {
      breakpoint = RESOLUTIONS.HIGH;
    } else {
      breakpoint = RESOLUTIONS.MIN;
    }

    this.setState({ breakpoint, screenWidth, screenHeight }, () => {
      this.getInteriorWall(screenWidth, screenHeight);
    });
  };

  componentDidMount() {
    this.parseUrlParams();

    this.screenObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const screenWidth = entry.contentRect.width;
        const screenHeight = entry.contentRect.height;
        this.updateScreenBreakpoint(screenWidth, screenHeight);
      });
    });

    const htmlEl = document.querySelector("html");
    this.screenObserver.observe(htmlEl);
  }
  componentDidUpdate(prevProps) {
    const pathname = window.location.pathname;
    const matches = pathname.split("/");
    const { location } = this.props;
    const { id } = this.state;
    if (prevProps.location !== location) {
      this.parseUrlParams();
    }
    if (matches) {
      const [, , , , shareNumber] = matches;
      if (shareNumber && shareNumber !== id) {
        this.setState({ id: shareNumber });
      }
    }
  }

  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };
  closeModal = () => {
    this.setState({ modalOpen: false });
  };
  setModalContent = (closeModal, customTitle, customFooter) => {
    if (closeModal === "TIMEOUT_CLOSE") {
      this.toggleModal();
      setTimeout(this.closeModal, 3000);
      this.setState({ customTitle, customFooter });
    } else if (closeModal === "CLOSE") {
      this.closeModal();
      this.setState({ customTitle, customFooter });
    } else {
      this.toggleModal();
    }
    if (customTitle === "Ticket Cancelled.") {
      this.setState({ modalOpen: true, customTitle, customFooter });
    } else if (closeModal !== "CLOSE" && closeModal !== "TIMEOUT_CLOSE") {
      this.setState({ customTitle, customFooter });
    }
  };

  setWhiteListModal = (whitelist, id) => {
    this.setState({ whitelist, id, whitelistModalOpen: true });
  };
  getInteriorWall(screenWidth) {
    const { breakpoint } = this.state;
    const interiorWallElement = document.querySelector(".interior-wall");
    if (
      (interiorWallElement && screenWidth <= 1899) ||
      (interiorWallElement && screenWidth <= 1280)
    ) {
      interiorWallElement.classList.remove("lg");
      interiorWallElement.classList.remove("md");
    }

    let interiorWall = `${CDN_URL}common/gray-interior-wall-md.svg`;
    if (breakpoint === RESOLUTIONS.LOW && screenWidth < 1280) {
      interiorWall = `${CDN_URL}common/gray-interior-wall-sm.svg`;
    } else if (breakpoint === RESOLUTIONS.HIGH || screenWidth >= 1899) {
      if (interiorWallElement) {
        interiorWallElement.classList.add("lg");
      }
      interiorWall = `${CDN_URL}common/gray-interior-wall-lg.svg`;
    } else if (breakpoint === RESOLUTIONS.LOW && screenWidth >= 1280) {
      interiorWall = `${CDN_URL}common/gray-interior-wall-md.svg`;
      if (interiorWallElement) {
        interiorWallElement.classList.add("md");
      }
    }

    this.setState({ interiorWall });
  }

  render() {
    const {
      breakpoint,
      PageComponent,
      currentModule,
      screenWidth,
      screenHeight,
      modalContent,
      modalOpen,
      headerText,
      customTitle,
      customFooter,
      interiorWall,
    } = this.state;

    const {
      history,
      match,
      navigate,
      location,
      company_info: { customer: { id } = {} },
    } = this.props;

    return (
      <div className="portal-layout v3">
        {breakpoint === RESOLUTIONS.MIN && (
          <LowResMessage
            screenWidth={screenWidth}
            screenHeight={screenHeight}
          />
        )}
        <div className="portal-header">
          <HeaderSection
            breakpoint={breakpoint}
            module={currentModule}
            navigate={navigate}
          />
        </div>
        <div className="portal-main">
          <div className="main-nav">
            <NavSection navigate={navigate} module={currentModule} />
          </div>
          <div className="main-portal-modal-overlay" />
          <div className="main-content" id="main-content">
            <div className="interior-wall">
              {interiorWall && <img src={interiorWall} />}
            </div>
            <div className="horizontal-bar" />
            {PageComponent && (
              <ContentSection
                content={PageComponent}
                breakpoint={breakpoint}
                match={match}
                history={history}
                setModalContent={this.setModalContent}
                setWhiteListModal={this.setWhiteListModal}
                navigate={navigate}
                location={location}
              />
            )}
          </div>
        </div>
        <div className="portal-alert-banner">
          <AlertBanner breakpoint={breakpoint} orgId={id} />
        </div>
        <div className="portal-footer">
          <FooterSection breakpoint={breakpoint} />
        </div>
        {modalOpen && (
          <Modal>
            <PopUp
              showModal={modalOpen}
              closeModal={this.toggleModal}
              customBody={modalContent}
              footer={customFooter}
              title={headerText}
              text={customTitle}
              module={currentModule}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default PortalLayout;
